[{"percentage":50,"time":2},{"percentage":70,"time":3}]